var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-ons-page",
    { attrs: { id: "app" } },
    [
      _c(
        "v-ons-splitter",
        [
          _c(
            "v-ons-splitter-side",
            {
              attrs: {
                swipeable: "",
                side: "left",
                collapse: "",
                animation: _vm.$ons.platform.isAndroid() ? "overlay" : "reveal",
                open: _vm.menuIsOpen
              },
              on: {
                "update:open": function($event) {
                  _vm.menuIsOpen = $event
                }
              }
            },
            [_c("menu-page")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-ons-splitter-content",
            [
              _c(
                "transition",
                { attrs: { name: "fade-transform", mode: "out-in" } },
                [_c("router-view", { key: _vm.key })],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-ons-modal",
        { attrs: { visible: _vm.$store.state.onsen.modalVisible } },
        [
          _c(
            "p",
            { staticClass: "text-center" },
            [
              _vm._v("\n      Loading\n      "),
              _c("v-ons-icon", { attrs: { icon: "fa-spinner", spin: "" } })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-ons-toast",
        {
          staticClass: "toast-error",
          attrs: {
            visible: _vm.$store.state.onsen.toastVisible,
            animation: "fall",
            animationOptions: "timeout: 0.2"
          }
        },
        [_vm._v(_vm._s(_vm.$store.state.onsen.toastMessage))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 